//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { required, between, decimal } from 'vuelidate/lib/validators';
import convert from 'convert-units';
import ValidationMixin from '../../../../common/form/mixins/ValidationMixin';

export default {
  name: 'MemberHeight',
  mixins: [ValidationMixin],
  props: ['value', 'updating', 'metric'],
  computed: {
    height() {
      if (this.value === null) {
        return null;
      }
      if (!this.isFloat(this.value)) {
        return this.value;
      }
      return Math.ceil(convert(this.value).from('m').to('in'));
    },
    inches() {
      if (this.height === null) {
        return '';
      }
      return Math.round(this.height % 12);
    },
    feet() {
      if (this.height === null) {
        return '';
      }
      return Math.floor(this.height / 12);
    },
    meters() {
      try {
        if (this.value === null) {
          return null;
        }
        let decimals = this.value.toString().split('.')[1].length || 0;
        if (decimals > 2) {
          decimals = 2;
        }
        return this.value.toFixed(decimals);
      } catch (e) {
        if (e instanceof TypeError) {
          return this.value;
        }
        throw e;
      }
    },
    imperialOptions() {
      const ret = { feet: [{ value: '', text: 'Feet' }], inches: [{ value: '', text: 'Inches' }] };
      for (let i = 1; i <= 9; i += 1) {
        ret.feet.push({ value: i, text: `${i} '` });
      }
      for (let i = 0; i <= 11; i += 1) {
        ret.inches.push({ value: i, text: `${i} "` });
      }
      return ret;
    },
  },
  validations: {
    height: {
      // required,
      decimal,
      // between: between(24.0, 120.0),
    },
  },
  methods: {
    onFeet(feet) {
      const inches = this.$refs.inches.value;
      this.$emit('input', convert(feet * 12 + inches).from('in').to('m'));
    },
    onInches(inches) {
      const feet = this.$refs.feet.value;
      this.$emit('input', convert(feet * 12 + inches).from('in').to('m'));
    },
    isFloat(n) {
      try {
        return n.toString().match(/^\d+(\.\d+)?$/);
      } catch (e) {
        return false;
      }
    },
    getErrors() {
      const errors = [];
      if (!this.$v.height.required) {
        errors.push('Height is required');
      }
      if (!this.$v.height.decimal) {
        errors.push('Height must be a number');
        return errors;
      }
      if (!this.$v.height.between) {
        errors.push('You appear to have a typo in your height');
      }
      return errors;
    },
  },
};
